import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentEmpid, selectCurrentUser } from '../../../pages/login/authSlice';
import { useGetResolutionReasonsQuery, useUpdateAllDisputesMutation } from '../disputeSlice';
import { recalculateAssociate } from '../../../components/recalculateAssociate/recalculateAssociate';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

type CloseAllDisputeProps = {
    empDailyResultIds: any;
    disputeDialogEnable: boolean;
    closeAllDisputes: (message: boolean) => void;
    employeenumber: number | undefined;
    year: number | undefined;
    month: number | undefined;
    scorecardVersionId: number | undefined;
};

export const CloseAllDisputes = ({
    empDailyResultIds,
    disputeDialogEnable,
    closeAllDisputes,
    employeenumber,
    year,
    month,
    scorecardVersionId,
}: CloseAllDisputeProps) => {
    const [UpdateAllDisputes] = useUpdateAllDisputesMutation();
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedUser = useSelector(selectCurrentUser);
    const [disputeModalResolutionReason, setDisputeModalResolutionReason] = useState<any>(0);
    const [disputeModalResolutionComment, setDisputeModalResolutionComment] = useState<any>('');
    const [disputeDialog, setDisputeDialog] = useState<boolean>(false);
    const [disableSaveClick, setDisableSaveClick] = useState<boolean>(true);
    const [disableControls, setDisableControls] = useState<boolean>(false);
    const toast = useRef<Toast>(null);

    useEffect(() => {
        setDisputeDialog(disputeDialogEnable);
    }, [disputeDialogEnable]);

    const { data: resolutionReasons } = useGetResolutionReasonsQuery({ typeId: 2 });

    const disputeModalHeader = () => {
        return (
            <h5 className="pe-3">
                <span style={{ fontSize: '16px', fontWeight: 700 }} className="pt-2">
                    Close All Disputes
                </span>
            </h5>
        );
    };
    const dialogFuncMap = {
        disputeDialog: setDisputeDialog,
    };

    const hideDisputeDialog = () => {
        dialogFuncMap.disputeDialog(false);
        setDisableControls(false);
        setDisputeModalResolutionComment('');
        setDisputeModalResolutionReason(0);
        closeAllDisputes(false);
    };

    const onSaveClick = () => {
        const payload = {
            employeenumber,
            year,
            month,
            scorecardVersionId,
            disputeStatusId: 2,
            reviewStatusId: 2,
            resolutionComment: disputeModalResolutionComment,
            resolutionReasonId: disputeModalResolutionReason,
            resolvedBy: loggedEmpNum,
            empDailyResultIds,
        };
        setDisableSaveClick(true);
        setDisableControls(true);
        CloseAllDisp(payload);
    };

    useEffect(() => {
        if (disputeModalResolutionReason > 0 && disputeModalResolutionComment.length > 5) {
            setDisableSaveClick(false);
        } else {
            setDisableSaveClick(true);
        }
    }, [disputeModalResolutionComment, disputeModalResolutionReason]);

    const CloseAllDisp = (reviewStatus: any) => {
        UpdateAllDisputes(reviewStatus)
        .unwrap()
        .then(() => {
            recalculateAssociate(
                reviewStatus.employeenumber,
                reviewStatus.scorecardVersionId,
                reviewStatus.year,
                reviewStatus.month,
                loggedEmpNum
            );

            setDisableSaveClick(true);
            toast.current?.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Save Success',
                life: 3000,
            });
            hideDisputeDialog();
        })
        .then((error: any) => {
            if (error) {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
            }
            setDisableSaveClick(true);
        });
    };
    const disputeModalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <Button
                    className="btn-primary w-auto float-end"
                    // style={{ fontSize: '14px', borderRadius: '8px' }}
                    disabled={disableSaveClick}
                    onClick={onSaveClick}
                >
                    Save Changes
                </Button>
                <Button
                    className="btn-secondary w-auto float-end"
                    // style={{ fontSize: '14px', borderRadius: '8px' }}
                    onClick={hideDisputeDialog}
                >
                    Cancel
                </Button>
            </React.Fragment>
        );
    };
    return (
        <Dialog
            visible={disputeDialog}
            style={{ width: '50vw' }}
            header={disputeModalHeader}
            modal
            className="p-fluid disputeModal"
            onHide={hideDisputeDialog}
            footer={disputeModalFooter}
        >
            <div className="row">
                <Toast ref={toast} />
                <Divider className="m-0 pb-4" />
                <div className="col-md-11 pe-0" style={{ width: '95.6%' }}>
                    <Button className="p-button text-center w-100 borderRadius" label="Disputes" />

                    <div className="row pt-3">
                        <div className="col-md-6 pt-1">
                            <div className="row">
                                <div className="col-md-10">
                                    <h6 className="mt-3 pt-2">Resolution Reason</h6>
                                    <Dropdown
                                        disabled={disableControls}
                                        value={disputeModalResolutionReason}
                                        options={resolutionReasons?.data}
                                        onChange={(e) => setDisputeModalResolutionReason(e.target.value)}
                                        optionLabel="reason_name"
                                        optionValue="reason_id"
                                        placeholder="Select Reason"
                                        className="borderRadius"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <DescriptionBox
                                title="Resolution Comment"
                                responseDescription={disputeModalResolutionComment}
                                value={disputeModalResolutionComment}
                                limit={1000}
                                onChange={(value) => setDisputeModalResolutionComment(value)}
                                disabled={disableControls}
                            />
                            <div className="row disputeCommentFooterText">
                                <div className="col-md-6">
                                    {new Date().toLocaleString('en-US', { dateStyle: 'medium' })}
                                </div>
                                <div className="col-md-6 text-end">Added by {loggedUser}.</div>
                            </div>
                            <div className="row disputeCommentFooterText">
                                <div className="col-md-12">*Comments appended to all selected disputes.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
